export const getTotalDiscount = (discount1, discount2, discount3) => {
  let a = discount1 / 100.0;
  let b = discount2 / 100.0;
  let c = discount3 / 100.0;

  const total = 1 - (1 - a) * (1 - b) * (1 - c);

  return (total * 100).toFixed(2);
};

export const getTotalDiscountForOrder = (order) => {
  let discount1 = order.discount1 ?? 0;
  let discount2 = order.discount2 ?? 0;
  let discount3 = order.discount3 ?? 0;

  return getTotalDiscount(discount1, discount2, discount3);
};
